import React, { createContext, useContext, useEffect, useState } from 'react';

// The core idea of this portfolio: one person, two lenses.
// 'strategist' frames everything as problem → insight → outcome.
// 'builder' frames the same work as architecture → stack → decisions.
const LensContext = createContext({ lens: 'strategist', setLens: () => {} });

const STORAGE_KEY = 'portfolio-lens';

export const LENSES = {
    strategist: { key: 'strategist', label: 'Strategist' },
    builder: { key: 'builder', label: 'Builder' },
};

export function LensProvider({ children }) {
    const [lens, setLens] = useState(() => {
        if (typeof window === 'undefined') return 'strategist';
        const saved = window.localStorage.getItem(STORAGE_KEY);
        return saved === 'builder' || saved === 'strategist' ? saved : 'strategist';
    });

    useEffect(() => {
        window.localStorage.setItem(STORAGE_KEY, lens);
        document.documentElement.setAttribute('data-lens', lens);
    }, [lens]);

    return (
        <LensContext.Provider value={{ lens, setLens }}>
            {children}
        </LensContext.Provider>
    );
}

export const useLens = () => useContext(LensContext);
